// extracted by mini-css-extract-plugin
module.exports = {"audioTime":"AudioTime_audioTime__kdjV2","totalTime":"AudioTime_totalTime__OJ4zS"};